export default __webpack_public_path__ + "static/media/peripheral2.3fa9f935.jpg";